import React from 'react'
import { CancelModal } from './components/CancelModal';

export const sortData = (data, sortOrder, sortType) => {
  if (sortType === 'percent') {
    if (sortOrder === 1) return data.slice().sort((a, b) => (a.percentDone > b.percentDone ? 1 : -1));
    else return data.slice().sort((a, b) => (a.percentDone < b.percentDone ? 1 : -1));
  } else if (sortType === 'total') {
    if (sortOrder === 1) return data.slice().sort((a, b) => (a.total > b.total ? 1 : -1));
    else return data.slice().sort((a, b) => (a.total < b.total ? 1 : -1));
  } else if (sortType === 'scanned') {
    if (sortOrder === 1) return data.slice().sort((a, b) => (a.scanned > b.scanned ? 1 : -1));
    else return data.slice().sort((a, b) => (a.scanned < b.scanned ? 1 : -1));
  } else if (sortType === 'name') {
    if (sortOrder === 1) return data.slice().sort((a, b) => (a.name > b.name ? 1 : -1));
    else return data.slice().sort((a, b) => (a.name < b.name ? 1 : -1));
  } else {
    if (sortOrder === 1) return data.slice().sort((a, b) => (a.name > b.name ? 1 : -1));
    else return data.slice().sort((a, b) => (a.name < b.name ? 1 : -1));
  }
};

function getEditCell({ value, row }: any) {
  if (value != null) {
    return <div>{row.requestNumber}</div>;
  } else {
    return '';
  }
}

function combineRequestorInfo({ value, row }: any) {
  if (value != null) {
    return (
      <div>
        {row._original.requestorName}
        <br />
        {row._original.requestorPhoneNumber}
        <br />
        {row._original.requestorEmail}
      </div>
    );
  } else {
    return '';
  }
}

function cancelRequest({value, row}: any){
  if(value !== null){
    if(row.status !== 'Cancelled'){
      return <CancelModal data={row} />;
    }
    return ''
  }
  return ''
}

export const userRequestColumns = [
  {
    column: {
      Header: 'Request #',
      accessor: 'id',
      type: 'string',
      resizable: true,
      width: 70,
      Cell: getEditCell,
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'requestNumber',
      show: false,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Requestor',
      accessor: 'requestorName',
      type: 'string',
      resizable: true,
      Cell: combineRequestorInfo,
      width: 175,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department',
      resizable: true,
      accessor: 'requestingDepartment',
      type: 'string',
      width: 85,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Category',
      resizable: true,
      accessor: 'equipmentCategory',
      width: 65,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Equipment Type',
      accessor: 'equipmentType',
      resizable: true,
      width: 300,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Quantity',
      accessor: 'quantity',
      type: 'number',
      resizable: true,
      width: 70,
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Notes',
      accessor: 'notes',
      type: 'string',
      resizable: true,
      // width: 725,
      style: { 'white-space': 'unset' },
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Status',
      accessor: 'status',
      type: 'string',
      width: 200,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Cancel?',
      type: 'string',
      width: 70,
      resizable: true,
      style: { textAlign: 'center' },
      Cell: cancelRequest,
    },
    type: 'string',
  },
];